import styled from "styled-components";
import { Button } from "react-bootstrap";

export const DateContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const From = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.orangeBackground};
  margin-bottom: 5px;
`;

export const StyledButton = styled(Button)`
  height: 35px;
  max-width: 175px; 
  background-color: ${({ theme }) => theme.orangeBackground};
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  padding: 0 30px;
  margin-left: 20px;
`;

export const CustomDatePickerInput = styled.input`
  width: 150px;
  height: 35px;
  color: #808080;
  border: 1px solid #cdcdcd;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  cursor: pointer;
`;
